module.exports = __webpack_public_path__ + "img/user-deleted.175bc2f.gif";